import { FC } from 'react';
import Divider from 'src/components/Divider';
import { SupplierInfo } from 'src/services/useInvoiceDetailsApi';

interface SupplierInfoDialogContentProps {
  supplierInfo: SupplierInfo;
}

const SupplierInfoDialogContent: FC<SupplierInfoDialogContentProps> = ({ supplierInfo }) => (
  <div className="min-w-[300px]">
    <div> Supplier : </div>
    <Divider />
    <div>{supplierInfo?.name}</div>
    <div>{supplierInfo?.companyName}</div>
    <div>{supplierInfo?.addressLine1}</div>
    <div>{supplierInfo?.addressLine2}</div>
    <div>
      {supplierInfo?.city}, {supplierInfo?.state} - {supplierInfo?.zipCode}
    </div>
    <div>{supplierInfo?.email}</div>
    {supplierInfo?.phone && (
      <div>
        <span className="font-semibold"> Phone: </span> {supplierInfo?.phone}
      </div>
    )}
    {supplierInfo?.fax && (
      <div>
        <span className="font-semibold">Fax: </span>
        {supplierInfo?.fax}
      </div>
    )}
  </div>
);

export default SupplierInfoDialogContent;
